// Master list of industries used across signup + case-study filtering.
export const INDUSTRIES = [
  { value: "saas", label: "SaaS / Software" },
  { value: "financial-services", label: "Financial Services" },
  { value: "fintech", label: "Fintech" },
  { value: "healthcare", label: "Healthcare" },
  { value: "life-sciences", label: "Life Sciences / Pharma" },
  { value: "retail", label: "Retail & E-commerce" },
  { value: "cpg", label: "CPG / Consumer Goods" },
  { value: "manufacturing", label: "Manufacturing" },
  { value: "automotive", label: "Automotive" },
  { value: "aviation", label: "Aviation & Transport" },
  { value: "energy", label: "Energy & Utilities" },
  { value: "real-estate", label: "Real Estate & Construction" },
  { value: "telecom", label: "Telecommunications" },
  { value: "media", label: "Media & Entertainment" },
  { value: "education", label: "Education / EdTech" },
  { value: "government", label: "Government / Public Sector" },
  { value: "legal", label: "Legal Services" },
  { value: "it-services", label: "Professional / IT Services" },
  { value: "insurance", label: "Insurance" },
  { value: "hospitality", label: "Hospitality & Travel" },
  { value: "other", label: "Other" },
];

export const COMPANY_SIZES = [
  { value: "lt100", label: "< 100" },
  { value: "100-500", label: "100 – 500" },
  { value: "500-1000", label: "500 – 1,000" },
  { value: "1000-5000", label: "1,000 – 5,000" },
  { value: "gt5000", label: "> 5,000" },
];

export const industryLabel = (value) =>
  INDUSTRIES.find((i) => i.value === value)?.label || value;

// Personal/free email domains we reject during signup
const FREE_EMAIL_DOMAINS = new Set([
  "gmail.com",
  "googlemail.com",
  "yahoo.com",
  "yahoo.co.in",
  "yahoo.co.uk",
  "ymail.com",
  "hotmail.com",
  "outlook.com",
  "live.com",
  "msn.com",
  "aol.com",
  "icloud.com",
  "me.com",
  "mac.com",
  "protonmail.com",
  "proton.me",
  "mail.com",
  "gmx.com",
  "rediffmail.com",
  "zoho.com",
  "yandex.com",
  "fastmail.com",
]);

export const isOfficialEmail = (email) => {
  if (!email) return false;
  const at = email.lastIndexOf("@");
  if (at < 1) return false;
  const domain = email.slice(at + 1).toLowerCase().trim();
  if (!domain.includes(".")) return false;
  return !FREE_EMAIL_DOMAINS.has(domain);
};
